import * as React from 'react';
import { Text } from 'wix-ui-tpa';
import { useTranslation } from 'react-i18next';
// Style
import { classes } from './Loader.st.css';
var Loader = function (_a) {
    var isPreLoaded = _a.isPreLoaded, locale = _a.locale, isLiveSite = _a.isLiveSite;
    var _b = useTranslation(), t = _b.t, i18n = _b.i18n;
    React.useEffect(function () {
        locale && void i18n.changeLanguage('locale');
    }, [locale]);
    return (React.createElement("div", { className: classes.bgColor },
        React.createElement("div", { className: classes.spinnerWrapper },
            React.createElement("svg", { className: classes.spinner, viewBox: "0 0 50 50" },
                React.createElement("circle", { className: classes.path, cx: "25", cy: "25", r: "20", strokeWidth: "3" }))),
        isPreLoaded ? (React.createElement("div", { className: classes.preLoaderTextWrapper },
            React.createElement("div", { className: classes.preLoaderTitleWrapper },
                React.createElement(Text, { className: classes.preLoaderTitle }, isLiveSite
                    ? t('calendar_widget_preLoaderTitle_LiveSite')
                    : t('calendar_widget_preLoaderTitle'))),
            React.createElement("div", null,
                React.createElement(Text, { className: classes.preLoaderSubTitle }, isLiveSite
                    ? t('calendar_widget_preLoaderSubTitle_LiveSite')
                    : t('calendar_widget_preLoaderSubTitle'))))) : null));
};
export default Loader;
//# sourceMappingURL=Loader.js.map